import { render, staticRenderFns } from "./boradcast.vue?vue&type=template&id=04b742b0&scoped=true&"
import script from "./boradcast.vue?vue&type=script&lang=js&"
export * from "./boradcast.vue?vue&type=script&lang=js&"
import style0 from "./boradcast.vue?vue&type=style&index=0&id=04b742b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b742b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b742b0')) {
      api.createRecord('04b742b0', component.options)
    } else {
      api.reload('04b742b0', component.options)
    }
    module.hot.accept("./boradcast.vue?vue&type=template&id=04b742b0&scoped=true&", function () {
      api.rerender('04b742b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/boradcast/boradcast.vue"
export default component.exports